import { ApiError } from '@restworld/utility-types';

export function extractApiErrors<T>(error: ApiError): { name: keyof T; type: string; message: string }[] {
  if (error?.code === 422 && error?.data?.errors) {
    return Object.entries(error.data.errors).map(([key, value]) => ({
      type: 'custom',
      name: key as keyof T,
      message: (value as string[])[0],
    }));
  }

  return [];
}
